var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9.25004C9.25011 8.70007 9.40139 8.16071 9.68732 7.69091C9.97325 7.22111 10.3828 6.83895 10.8713 6.58619C11.3597 6.33344 11.9083 6.21982 12.4569 6.25776C13.0056 6.29569 13.5333 6.48372 13.9823 6.80129C14.4313 7.11886 14.7844 7.55375 15.0029 8.05843C15.2215 8.56311 15.2971 9.11816 15.2215 9.66291C15.1459 10.2077 14.9221 10.7212 14.5744 11.1473C14.2267 11.5734 13.7685 11.8957 13.25 12.079C12.9574 12.1825 12.7041 12.3741 12.525 12.6275C12.3459 12.881 12.2498 13.1837 12.25 13.494V14.5",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 18.25C12.0429 18.25 11.875 18.0821 11.875 17.875C11.875 17.6679 12.0429 17.5 12.25 17.5",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 18.25C12.4571 18.25 12.625 18.0821 12.625 17.875C12.625 17.6679 12.4571 17.5 12.25 17.5",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 23.5C18.4632 23.5 23.5 18.4632 23.5 12.25C23.5 6.0368 18.4632 1 12.25 1C6.0368 1 1 6.0368 1 12.25C1 18.4632 6.0368 23.5 12.25 23.5Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export default SvgQuestionCircle;